import { render, staticRenderFns } from "./StorageManage.vue?vue&type=template&id=5640561a&scoped=true&"
import script from "./StorageManage.vue?vue&type=script&lang=js&"
export * from "./StorageManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5640561a",
  null
  
)

export default component.exports